import { render, staticRenderFns } from "./provider-list-sort-component.vue?vue&type=template&id=5c26bc7c&scoped=true&"
import script from "./provider-list-sort-component.vue?vue&type=script&lang=js&"
export * from "./provider-list-sort-component.vue?vue&type=script&lang=js&"
import style0 from "./provider-list-sort-component.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./provider-list-sort-component.vue?vue&type=style&index=1&id=5c26bc7c&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5c26bc7c",
  null
  
)

export default component.exports